import { connect } from 'react-redux';
import UserProfileComponent from '../views/users/MyprofileComponent';
import { incrementCount } from '../../redux/actions/authentication';

const mapStateToProps = (state) => ({
    count : state.authentication.count
});

const mapDispatchToProps = (dispatch) => ({
    incrementCount : () => dispatch(incrementCount())
});

const UserProfile = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfileComponent);

export default UserProfile;